import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http';
import type {
    PsHttp,
    PatSnapSuccessResponseData,
} from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { PsHttpChannel } from '@patsnap/tahiti-core';
import { coreTelecomApiUrlPrefix } from '@telecom/shared/domain-config';
import type { LanguageApi } from '../language-api';
import type {
    DetectLanguageRequest,
    DetectLanguageResponse,
    TranslateTextRequest,
    TranslateTextResponse,
} from '../types/language';

/**
 * 语言服务 API 实现
 * @description 实现语言检测和翻译功能
 */
@injectable()
export class LanguageApiImpl extends PsHttpService implements LanguageApi {
    constructor(httpClient: PsHttp, httpChannelClient: PsHttpChannel) {
        super(httpClient, httpChannelClient);
    }

    get options() {
        return {
            baseURL: coreTelecomApiUrlPrefix,
            headers: {
                'Content-Type': 'application/json',
            },
        };
    }

    /**
     * 检测输入文本的语言
     */
    async detectLanguage(data: DetectLanguageRequest) {
        const res = await this.post<PatSnapSuccessResponseData<DetectLanguageResponse>>({
            url: '/ai/task/lang-detect',
            data,
        });
        return res.data;
    }

    /**
     * 翻译文本
     */
    async translateText(data: TranslateTextRequest) {
        const res = await this.post<PatSnapSuccessResponseData<TranslateTextResponse>>({
            url: '/translation/text',
            data,
        });
        return res.data;
    }
}
